export class PostSocieteLie {
  contactId?: number;
}
